import { defineStore } from "pinia";

export const useStorageStore = defineStore("storage", {
  state: () => ({
    token: "",
    payment_methods: [],
    store: {},
    home: {},
    configuration: {}
  }),
  persist: {
    pick: ["token", "store"],
  },
  getters: {},
  actions: {
    setToken(value){
      this.token = value;
    },
    setPaymentMethods(value){
      this.payment_methods = value;
    },
    setConfiguration(value) {
      this.configuration = value;
    }
  },
});
